import policy from './firstCutoverPolicy.json';
import productionActivation from './productionActivatedRoutes.json';

const READ_ONLY_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const routePattern = (template) => {
  const segments = template.split('/').map((segment) => {
    if (/^\{[A-Za-z0-9_]+\}$/.test(segment)) return '[^/]+';
    return escapeRegExp(segment);
  });
  return new RegExp(`^${segments.join('/')}$`);
};

const blockedRoutes = policy.routes.map((route) => ({
  ...route,
  pattern: routePattern(route.path),
}));
const deploymentEnvironment = String(process.env.REACT_APP_ENVIRONMENT || '').toLowerCase();
const productionActivationValid = (
  productionActivation?.schema_version === 1
  && productionActivation?.profile_id === 'batchtrue-e2e-canary-20260901'
  && productionActivation?.environment === 'production'
  && Array.isArray(productionActivation?.routes)
  && productionActivation.routes.length === 5
  && productionActivation.routes.every(route => (
    Object.keys(route || {}).sort().join(',') === 'method,path'
  ))
  && productionActivation.routes.map(route => `${route.method} ${route.path}`).sort().join(',') === 'POST /api/admin/customers,POST /api/admin/email-templates/test,POST /api/admin/products,PUT /api/admin/customers/{customer_id}/archive,PUT /api/admin/order-drafts/{draft_id}'
);
const productionRoutes = productionActivationValid
  ? productionActivation.routes.map((route) => ({
      ...route,
      pattern: routePattern(route.path),
    }))
  : [];

const normalizedPath = (rawPath) => {
  const withoutQuery = String(rawPath || '').split('?')[0];
  if (withoutQuery.startsWith('/api/')) return withoutQuery;
  if (withoutQuery.startsWith('/')) return `/api${withoutQuery}`;
  return `/api/${withoutQuery}`;
};

export const FIRST_CUTOVER_POLICY_ID = policy.policy_id;
export const FIRST_CUTOVER_POLICY_ENFORCED = policy.enforced === true;

export const firstCutoverBlock = (method, rawPath) => {
  const normalizedMethod = String(method || 'GET').toUpperCase();
  if (!FIRST_CUTOVER_POLICY_ENFORCED || READ_ONLY_METHODS.has(normalizedMethod)) {
    return null;
  }
  const path = normalizedPath(rawPath);
  if (
    deploymentEnvironment === 'production'
    && productionRoutes.some(
      (route) => route.method === normalizedMethod && route.pattern.test(path)
    )
  ) {
    return null;
  }
  return blockedRoutes.find(
    (route) => route.method === normalizedMethod && route.pattern.test(path)
  ) || null;
};

export const firstCutoverBlockedRoutes = policy.routes;
export const productionActivatedRoutes = productionActivation.routes;
